<script lang="ts" setup></script>

<template>
    <div class="py:8 relative mx-auto flex w-full grow flex-col px-4 lg:px-6 lg:py-6">
        <slot />
    </div>
</template>
